export default class Webhook {
  constructor(hook) {
    hook = hook || {}; // if a hook is supplied, use it for instantiation
    this.name = typeof hook.name !== "undefined" ? hook.name : null;
    this.url = typeof hook.url !== "undefined" ? hook.url : null;
    this.disabled =
      typeof hook.disabled !== "undefined" ? hook.disabled : false;
    this.batch = typeof hook.batch !== "undefined" ? hook.batch : false;
    this.reliable = typeof hook.reliable !== "undefined" ? hook.reliable : true;
    this.events = typeof hook.events !== "undefined" ? hook.events : [];
  }
}
